import Vue from 'vue'
import Vuex from 'vuex'

import actions from './actions'
import attendances from './modules/attendances'
import constants from './modules/constants'
import contracts from './modules/contracts'
import costCenters from './modules/costCenters'
import providers from './modules/providers'
import users from './modules/users'
import workers from './modules/workers'
import purchaseOrders from './modules/purchaseOrders'
import computingMetrics from './modules/computingMetrics'
import invoices from './modules/invoices'

const fb = require('../firebaseConfig.js')
const utils = require('../utils.js');

Vue.use(Vuex)

fb.auth.onAuthStateChanged(user => {
	if(user) {
		store.commit('setCurrentUser', user)
		store.dispatch('fetchUserProfile')
		store.dispatch('fetchCompanyData')
	}
})

export const store = new Vuex.Store({
	modules: {
		attendances,
		computingMetrics,
		constants,
		contracts,
		costCenters,
		invoices,
		providers,
		purchaseOrders,
		users,
		workers,
	},
	state: {
		active: ['Yes', 'No'],
		companyData: {},
		currentRoute: '',
		loadingWorker: false,
		positions: [],
		uoms: ['ml', 'm2', 'm3', 'un'],
		status: [{sequence: 1, value: 'Open'},{sequence: 2, value: 'Work in Progress'},{sequence: 3, value: 'Finished'},{sequence: 4, value: 'Cancelled'}],
	},
	getters: {
		currentDate: () => {
			let date = new Date()
			return fb.firestore.Timestamp.fromDate(date)
		},
		uoms: (state) => {
			return state.uoms
		},
		status: (state) => {
			return utils.sortArray(state.status, 'sequence')
		},
		defaultStatus: (state) => {
			return state.status[0]
		},
		companyData: (state) => {
			return state.companyData
		}
	},
	mutations: {
		setPositions(state, val) {
			state.positions = val
		},
		setCurrentRoute(state, val) {
			state.currentRoute = val
		},
		setCompanyData(state,val) {
			state.companyData = val
		}
	},
	actions
})